// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GenericLayerProperties
 */
export interface GenericLayerProperties {
  /**
   *
   */
  styleId?: string | null;
  /**
   *
   */
  type?: GenericLayerPropertiesTypeEnum;
}

/**
 * @export
 */
export const GenericLayerPropertiesTypeEnum = {
  Generic: "generic",
} as const;
export type GenericLayerPropertiesTypeEnum =
  (typeof GenericLayerPropertiesTypeEnum)[keyof typeof GenericLayerPropertiesTypeEnum];

/**
 * Check if a given object implements the GenericLayerProperties interface.
 */
export function instanceOfGenericLayerProperties(value: object): value is GenericLayerProperties {
  return true;
}

export function GenericLayerPropertiesFromJSON(json: any): GenericLayerProperties {
  return GenericLayerPropertiesFromJSONTyped(json, false);
}

export function GenericLayerPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GenericLayerProperties {
  if (json == null) {
    return json;
  }
  return {
    styleId:
      json["style_id"] === undefined
        ? undefined
        : json["style_id"] === null
        ? null
        : json["style_id"],
    type: json["type"] == null ? undefined : json["type"],
  };
}

export function GenericLayerPropertiesToJSON(json: any): GenericLayerProperties {
  return GenericLayerPropertiesToJSONTyped(json, false);
}

export function GenericLayerPropertiesToJSONTyped(
  value?: GenericLayerProperties | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    style_id: value["styleId"],
    type: value["type"],
  };
}
